import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Wraps route content and plays a short, subtle fade + lift whenever the
 * pathname changes, so navigating between pages feels smooth instead of abrupt.
 */
export function PageTransition({
  children
}: PageTransitionProps) {
  const {
    pathname
  } = useLocation();
  return <motion.div key={pathname} initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.35,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-346" data-mp="2q45g23cpi9of">
      {children}
    </motion.div>;
}